import { render, staticRenderFns } from "./ChevronDownIcon.vue?vue&type=template&id=3b3afefe&scoped=true"
import script from "./ChevronDownIcon.vue?vue&type=script&lang=js"
export * from "./ChevronDownIcon.vue?vue&type=script&lang=js"
import style0 from "./ChevronDownIcon.vue?vue&type=style&index=0&id=3b3afefe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3afefe",
  null
  
)

export default component.exports